import { Pane, Text, Heading } from 'evergreen-ui';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { SuccessIcon } from '../../components/icons';

const EmailVerificationSuccessPage = () => {
  const navigate = useNavigate();
  useEffect(() => {
    const timer = setTimeout(() => {
      navigate('/app/login');
    }, 5000);
    return () => clearTimeout(timer);
  });

  return (
    <Pane
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      height="100%"
      padding={16}
      paddingTop={0}
    >
      <SuccessIcon />
      <Heading color="#edeef2" size={700}>
        Email Verified!
      </Heading>
      <Pane display="flex" justifyContent="center" alignItems="center" paddingY={32}>
        <Text color="#636465">Redirecting to login... Click</Text>
        <Text
          fontWeight="bolder"
          color="#e78850"
          onClick={() => navigate('/app/login', { replace: true })}
          marginLeft={5}
          marginRight={5}
          cursor="pointer"
        >
          here
        </Text>
        <Text color="#636465">in nothing happens</Text>
      </Pane>
    </Pane>
  );
};

export default EmailVerificationSuccessPage;
